import styled from '@emotion/styled'

interface NavigationProps {
  disabled: boolean
  underline: boolean
}

export const LinkStyledButton = styled.div<NavigationProps>`
  color: ${props => (props.disabled ? 'var(--White60)' : 'var(--Red-Dark)')};
  display: flex;
  flex-direction: row;
  align-items: center;
  background: none;
  border: none;
  text-decoration: ${props => (props.underline ? 'underline' : 'none')};
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  &:hover {
    color: ${props => (props.disabled ? 'var(--White60)' : 'var(--Graphite)')};
    text-decoration: ${props => (props.underline ? 'none' : 'none')};
  }
`
